import { ILLUSTRATIONS, type IllustrationKey } from '@/config/illustrations';
import { cn } from '@/lib/utils';

interface IllustrationProps {
  name: IllustrationKey;
  /** 크기 유틸(기본 `size-36`). rem 기반이라 루트 글자 배율과 함께 커진다. */
  className?: string;
}

/** 상태 일러스트 — 장식용(의미는 옆 제목·설명이 전달)이라 보조기기에서 숨긴다. */
export function Illustration({ name, className }: IllustrationProps) {
  const Svg = ILLUSTRATIONS[name];
  return <Svg aria-hidden="true" focusable="false" className={cn('size-36', className)} />;
}
